import React from 'react';
import { Link } from '~/ssrAdapter/react-router-dom';
import styled from 'styled-components';
import { Translation } from '~/components/Translation';
import Text from '~/components/Text';

const StepCardLink = styled(Link)`
	display: flex;
	width: 350px;
	flex-direction: column;
	align-items: flex-start;
	border-radius: 16px;
	box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.05);
	text-decoration: none;
	cursor: pointer;
	transition: transform 0.2s ease, box-shadow 0.2s ease;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 50px 0 rgba(0, 0, 0, 0.1);
	}

	@media (max-width: 500px) {
		max-width: 350px;
		width: 100%;
	}
`;

const StepImage = styled.img`
	display: flex;
	height: 200px;
	align-items: center;
	align-self: stretch;
	object-fit: cover;
	border-radius: 16px 16px 0 0;
`;

const ContentContainer = styled.div`
	display: flex;
	padding: 28px;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
	align-self: stretch;
`;

const TitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
	align-self: stretch;
`;

const StepLabel = styled(Text)`
	color: ${({ theme }) => theme.colors.primary.main};
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
`;

const StepTitle = styled(Text)`
	font-size: 20px;
	font-weight: 600;
	line-height: 1.3;
`;

const StepDescription = styled(Text)`
	color: ${({ theme }) =>
		theme.tokens.COLOR_TOKENS_TEXT_INVERTIBLE_NEUTRAL_NEUTRAL_STRONG};
	font-size: 14px;
	line-height: 1.5;
`;

interface StepCardProps {
	stepNumber: number;
	imageSrc: string;
	titleKey: string;
	descriptionKey: string;
	stepLabelKey?: string;
}

const StepCard: React.FC<StepCardProps> = ({
	stepNumber,
	imageSrc,
	titleKey,
	descriptionKey,
	stepLabelKey = 'landingRecordingsSimplified.gettingStarted.stepLabel',
}) => {
	return (
		<StepCardLink to="/signup">
			<StepImage src={imageSrc} alt="" />
			<ContentContainer>
				<TitleBlock>
					<StepLabel variant="body2">
						<Translation tid={stepLabelKey} /> {stepNumber}
					</StepLabel>
					<StepTitle variant="h4">
						<Translation tid={titleKey} />
					</StepTitle>
				</TitleBlock>
				<StepDescription variant="body">
					<Translation tid={descriptionKey} />
				</StepDescription>
			</ContentContainer>
		</StepCardLink>
	);
};

export default StepCard;
